<template>
    <transition name="fade" v-if="enableTool">
        <ControlAddFeature
            v-if="enableAddFeature"
            :data-panel="pageID"
            :idControl="pageID"
            :actionName="actionName"
            :moduleCode="moduleCode"
            :showButtonOnActionMap="showButtonOnActionMap"
            :eventInitialize="eventInitialize"
            :eventFinished="eventFinished"
            :eventShowModal="eventShowModal"
            />
    </transition>
</template>

<script>
    import ToolMixin from './mixins/ToolMixin';
    import { MAP_ACTIONS } from '@config/constants';

    export default {
        mixins: [
            ToolMixin,
        ],
        components: {
            ControlAddFeature: () => import(/* webpackChunkName: "control-addfeature" */ '@/components/maps/control/addFeatureControl'),
        },
        props: {
            toolId: {
                type: String,
                required: true,
            },
            actionName: {
                type: String,
                default: MAP_ACTIONS.NEW_OCCURRENCE,
            },
            eventInitialize: {
                type: String,
                default: 'map.new-feature-initialize',
            },
            eventFinished: {
                type: String,
                default: 'map.new-feature-finished',
            },
            eventShowModal: {
                type: String,
                default: 'map.new-feature-show-modal',
            },
        },
        data() {
            return {
                pageID: this.toolId,
            }
        },
        computed: {
            enableAddFeature() {
                return this.checkTool(this.pageID) && this.$auth.check(this.acl[`add${this.capitalizeFirstLetter(this.pageID.replace(/add/, ''))}`]);
            },
        },
        methods: {
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
        }
    }
</script>